import { render, staticRenderFns } from "./DesignComponentsHeader.vue?vue&type=template&id=a4dc1874&scoped=true"
import script from "./DesignComponentsHeader.vue?vue&type=script&lang=js"
export * from "./DesignComponentsHeader.vue?vue&type=script&lang=js"
import style0 from "./DesignComponentsHeader.vue?vue&type=style&index=0&id=a4dc1874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4dc1874",
  null
  
)

/* custom blocks */
import block0 from "./DesignComponentsHeader.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports